import { FILTER_TYPES } from "../../../../../../utils/filter";

const filterSalesWithDebit = (sales: Array<any>): Array<Object> =>
  sales.filter((sale) => sale.inDebit > 0);

const filterConfig = [
  {
    placeholder: "Ingresa el nombre de la tienda",
    type: FILTER_TYPES.TEXT,
    filterTitle: "Tienda",
    dataField: "storeName",
  },
];

export default filterConfig;
